import { Select } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AutoCompleteSearch from "../../../common/components/AutoComplete/AutoCompleteSearch";
import DataTable from "../../../common/components/DataTable/WhiteHeaderTable";
import { ExpandSVG } from "../../../common/components/icons/SVGIcon";
import ToastMessage from "../../../common/components/Toast";
import { addProcedureDetails, adminReferralConditionUpdate, getProviders, setProcedureDetails } from "../../../store/actions";

const ProcedureTimes = [
  { value: 30, label: "30 mins" },
  { value: 60, label: "60 mins" },
  { value: 90, label: "90 mins" },
  { value: 120, label: "120 mins" },
  { value: 150, label: "150 mins" },
  { value: 180, label: "180 mins" },
  { value: 210, label: "210 mins" },
  { value: 240, label: "240 mins" },
  { value: 270, label: "270 mins" },
  { value: 300, label: "300 mins" },
];

const ConditionProviders = ({ resource }) => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [isToastr, setIsToastr] = useState(false);
  const [checkNew, setCheckNew] = useState(false);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const conditionState = useSelector((state) => state.procedureDetail.conditions);
  const selectedReferralCondition = useSelector((state) => state.adminReferralCondition.selectedReferralCondition);
  const providers = useSelector((state) => state.common.providers);

  useEffect(() => {
    if (!providers || providers.length === 0) {
      dispatch(getProviders());
    }
  }, [providers]);

  const updateConditionProviders = async (type, index, value) => {
    if (type === "duration") {
      const dataCheck = [...conditionState];
      dataCheck[index][type] = value;
      dispatch(setProcedureDetails("conditions", [...dataCheck]));
    } else {
      const isValueSame = conditionState?.some((el) => {
        return el.physician_name === value?.value;
      });
      if (isValueSame) {
        setIsToastr(true);
        setTimeout(() => {
          setIsToastr(false);
        }, 2000);
        return;
      } else {
        await dispatch(
          addProcedureDetails("conditions", {
            physician_name: value?.value,
            physician: value?.id,
            duration: null,
          })
        );
      }
    }
    setCheckNew(true);
  };

  const removeConditionProvider = async (index) => {
    conditionState.splice(index, 1);
    await dispatch(setProcedureDetails("conditions", [...conditionState]));
    setCheckNew(true);
  };

  useEffect(() => {
    if (checkNew) {
      callApiUpdate();
    }
  }, [conditionState, checkNew]);

  useEffect(() => {
    if (selectedReferralCondition) {
      const providerDetail = (selectedReferralCondition.providers || []).map((r) => {
        return {
          physician: r?.id,
          physician_name: r?.value,
          duration: r?.pivot && r?.pivot?.interval === 0 ? undefined : r?.pivot?.interval || null,
        };
      });
      dispatch(setProcedureDetails("conditions", [...providerDetail]));
    }
    setCheckNew(false);
  }, [selectedReferralCondition]);

  useEffect(() => {
    if (providers) {
      setSearchResult(providers);
    }
  }, [providers]);

  useEffect(() => {
    if (search && search.length > 0) {
      const checkfilter = providers.filter((r) => r?.value.toLowerCase().includes(search.toLowerCase()));
      setSearchResult(checkfilter);
    } else {
      setSearchResult(providers);
    }
  }, [search]);

  useEffect(() => {
    // dispatch(getProviders());
  }, []);

  const emptyRows = useMemo(() => {
    if (tableRef && tableRef.current) {
      const total = Math.floor(tableRef.current.clientHeight / 40);
      const count = conditionState && conditionState.length > 0 ? total - conditionState.length : total;
      return new Array(count).fill(1);
    }
    return [];
  }, [tableRef, conditionState]);

  const callApiUpdate = () => {
    if (conditionState && selectedReferralCondition && Object.keys(selectedReferralCondition).length > 0) {
      const renderArray = conditionState.map((r) => {
        return `"${r.physician}":{"interval":${r.duration}}`;
      });
      dispatch(
        adminReferralConditionUpdate(selectedReferralCondition?.id, {
          value: selectedReferralCondition?.value,
          providers: `{${renderArray.join()}}`,
        })
      );
    }
  };

  if (resource === null || resource === undefined) {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {isToastr && <ToastMessage type="Provider Already Exists" status="failed" msg="Can Not Add Same Value!" />}
      <div style={{ width: "100%", minheight: "50px" }}>
        <AutoCompleteSearch
          isLargeHeight={true}
          title="Procedure-Provider-Search"
          options={searchResult}
          handlePopulate={(value) => updateConditionProviders("physician", conditionState.length, value)}
          handleSearch={(val) => setSearch(val)}
          placeholder="Search Providers"
          keyLabel="value"
          actionLabel="Add"
          backgroundWhite={"blue"}
        />
      </div>
      <div ref={tableRef} style={{ flex: 1, width: "100%" }}>
        <DataTable
          title="condition_provider"
          labels={["Provider"]}
          widths={["100%"]}
          fullHeight={true}
          columns={[{ sortable: true, key: "provider" }]}
          handleDelete={(value, index) => removeConditionProvider(index)}
          rowData={(conditionState || []).map((item, index) => {
            return {
              provider: item.physician_name,
              duration: (
                <Select
                  placeholder="Duration"
                  suffixIcon={<ExpandSVG />}
                  allowClear={false}
                  value={item.duration}
                  onChange={(value) => {
                    updateConditionProviders("duration", index, value);
                  }}
                  style={{ width: "100%", borderBottom: 0 }}
                >
                  {ProcedureTimes.map((r) => (
                    <Select.Option key={r?.value} value={r?.value}>
                      {r.label}
                    </Select.Option>
                  ))}
                </Select>
              ),
            };
          })}
          emptyRows={emptyRows}
          sorts={[""]}
        />
      </div>
    </div>
  );
};

export default ConditionProviders;
